module.exports = __webpack_public_path__ + "static/media/age-locker-bg.6235b801.jpg";